import { getSearchParam } from '../utils';

export const glSettings = {
    DEBUG_DRAW_COUNT: getSearchParam('drawcount'),
    USE_ORBIT_CONTROLS: getSearchParam('controls'),
    USE_GUI: getSearchParam('gui'),
};
